import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import ArrowDownIcon from '../../../icons/ArrowDownIcon';
import './FlightsFormStyles.css';
import FlightsScreenController from '../../../containers/flights/FlightsScreenController';

export default class FlightsFormMobile extends Component {
  static propTypes = {
    location: PropTypes.string,
    date: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    adults: PropTypes.number,
    infants: PropTypes.number,
    handleClickOpen: PropTypes.func,
    openCalendar: PropTypes.func,
  };

  render () {
    const { location, openCalendar, date, adults, infants, handleClickOpen } = this.props;
    let viewDate = FlightsScreenController.formatDateLongMonthWithDay(date);
    return (
      <div style={{ width: '100%' }}>
        <div className='flights-form-field-wrapper'>
          <label className='text-left'>
            {Dictionary.flights.from}&nbsp;
            {location}
          </label>
          <div className='flights-form-field'>
            <label onClick={openCalendar}>{viewDate}</label>
            <ArrowDownIcon style={{ marginLeft: -15, top: 15, width: 7, height: 5 }} />
          </div>
        </div>
        <div className='flights-form-field-wrapper'>
          <label className='text-left'>{Dictionary.flights.passengers}</label>
          <div className='flights-form-field'>
            <label onClick={handleClickOpen}>
              {adults}&nbsp;&nbsp;{Dictionary.flights.adults}&nbsp;&nbsp;&nbsp;&nbsp;
              {infants}&nbsp;&nbsp;{Dictionary.flights.infants}
            </label>
            <ArrowDownIcon style={{ marginLeft: -15, top: 15, width: 7, height: 5 }} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/flights/flightsForm/FlightsFormMobile.js